export const PROMO_CARD_SHADOW = '54.4018px 48.2777px 38.4193px rgba(0, 0, 0, 0.0566562), 37.865px 33.6025px 24.8484px rgba(0, 0, 0, 0.04725), 24.8343px 22.0387px 15.4189px rgba(0, 0, 0, 0.0404687), 14.959px 13.2751px 9.2625px rgba(0, 0, 0, 0.035), 7.88855px 7.00053px 5.51074px rgba(0, 0, 0, 0.0295312), 3.27229px 2.90392px 3.29531px rgba(0, 0, 0, 0.02275), 0.759638px 0.674125px 1.74785px rgba(0, 0, 0, 0.0133437)';
export const PROMO_DESCRIPTION_LINES = {
    sm: 6,
    md: 3,
    lg: 5,
};
